import React from "react";
import "../css/counselling.css";
import bgImg from "../assets/cta-card-bg3.jpg"; 
import book from "../assets/subtitle-icon1-5.svg";
import { useNavigate } from "react-router-dom";

// Note: "NewZealand" ko Header array ki tarah rakha hai taaki dash conversion sahi ho
const DESTINATIONS = [
  "Australia", "Canada", "France", "Germany", "Ireland", "Japan", 
  "Moldova", "NewZealand", "Netherlands", "Singapore", "UK", "USA", "UAE"
];

const CounsellingSection = () => {
  const navigate = useNavigate();

  // ✅ Header se match karta hua Dynamic Navigation Logic
  const handleCountryNavigation = (countryName) => {
    // Label ko lowercase aur spaces/slashes ko dashes me badalne ka common logic
    const dynamicPath = countryName
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/\//g, '-');

    // Sahi route par navigate karega
    navigate(`/study-abroad/${dynamicPath}`);
    
    // Page load hote hi screen automatically top par scroll ho jaye
    window.scrollTo(0, 0);
  };

  return (
    <>
      {/* DESTINATIONS */}
      <section className="dest-section">
        <div className="container">
          <div className="heading">
            <span className="pill">Study Abroad</span>
            <h2 className="couselling-h">Popular <span>Destinations</span></h2>
          </div>

          <div className="destinations">
            {DESTINATIONS.map((d, i) => (
              <button 
                key={i} 
                className="dest-btn"
                onClick={() => handleCountryNavigation(d)} // ✅ Click event add kiya
              >
                🌍 {d === "NewZealand" ? "New Zealand" : d} {/* UI par space ke sath dikhane ke liye */}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* COUNSELLING MAIN */}
      <section
        className="counselling-section"
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <div className="overlay"></div>

        <div className="content">
          <p className="subtitle"><img src={book} alt="counselling"/> Book your Counselling Session</p>

          <h1 className="couselling-h">
            Call To Book Your First Counselling <br />
            Session With Our Expert
          </h1>

          <h2 className="phone">(+91) 8287-543-429</h2>

          <button 
            className="btn" 
            onClick={() => {
              navigate("/register");
              window.scrollTo(0, 0); // Form par jate hi top scroll safely handle ho
            }}
          >
            REGISTER NOW →
          </button>
        </div>
      </section>
    </>
  );
};

export default CounsellingSection;